'use strict';

function ManagerRoutes ($stateProvider) {
  $stateProvider
  .state('manager', {
    url: '/manager',
    controller: 'ManagerController',
    controllerAs: 'managerCtrl',
    templateUrl: 'manager/manager.tpl.html',
    abstract: true,
    resolve: {

      authenticate: [
        '$location', '$state', '$q', '$timeout', 'AuthService',
        ($location, $state, $q, $timeout, AuthService) => {

          const deferred = $q.defer();
          const authenticated = AuthService.isAuthenticated();
          const params = {
            location: $location.path() === '/' ? '' : $location.path()
          };

          $timeout(() => {

            if (authenticated) {
              deferred.resolve();
            }
            else {
              $state.go('login', params);
              deferred.reject();
            }
          });

          return deferred.promise;
        }
      ],

      organization: [
        'sbFlux', 'authenticate', 'IngestorService',
        (Flux, authenticate, IngestorService) => {

          var OrganizationStore = Flux.Store.get('OrganizationStore');
          var PlanStore = Flux.Store.get('PlanStore');
          return OrganizationStore.loadOrganization()
          .then((organization) => {

            return PlanStore.preloadOrgPlanData()
          })
          .then(() => {
            IngestorService.attachIngestor()
          })

        }
      ]
    }
  })
  .state('manager.processingJobs', {
    url: '?page&search&sort',
    controller: 'ProcessingJobsController',
    controllerAs: 'vm',
    reloadOnSearch: false,
    templateUrl: 'manager/processing/processingJobs.tpl.html',
    resolve: {

      OrgProjects: [
        'ManagerStore', 'MetricsService',
        (ManagerStore, MetricsService) => {

          MetricsService.track('datasetManagerReady', 'datasetManagerNavigate', {
            forceNewFlow: true
          });
          return ManagerStore.loadProjects();
        }
      ]
    }
  })
  .state('manager.processingJobs.job', {
    url: '/:job',
    controller: 'ProcessingJobDetailController',
    controllerAs: 'vm',
    reloadOnSearch: false,
    templateUrl: 'manager/processing/processingJobDetail.tpl.html',
    resolve: {
      job: [
        'ManagerStore', '$stateParams', 'OrgProjects', 'ContourPreviewService',
        function (ManagerStore, $stateParams, OrgProjects, ContourPreviewService) {

          return new Promise((resolve) => {

            resolve(ManagerStore.fetchJobDetail($stateParams.job));
          })
          .then((job) => {

            if (job && job.hasOwnProperty('site') && job.hasOwnProperty('dataCapture') && job.hasOwnProperty('uuid')) {
              ContourPreviewService.setData({
                site: job.site,
                dataCapture: job.dataCapture,
                uuid: job.uuid
              });
            }

            return job;
          });
        }
      ]
    }
  })
  .state('manager.processingJobs.job.map', {
    abstract: true,
    resolve: {
      meta: [
        'job',
        (job) => {

          return job;
        }
      ]
    }
  });

}

ManagerRoutes.$inject = ['$stateProvider'];
module.exports = ManagerRoutes;



// WEBPACK FOOTER //
// ./src/app/manager/ManagerRoutes.js